import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

const AnonymousTest = () => {
  const { user, signInAnonymouslyUser, logout, isAuthenticated } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleAnonymousSignIn = async () => {
    try {
      setLoading(true);
      setError(null);
      console.log('Starting anonymous sign-in...');
      await signInAnonymouslyUser();
      console.log('Anonymous sign-in completed');
    } catch (err) {
      console.error('Anonymous sign-in failed:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      setLoading(true);
      await logout();
    } catch (err) {
      console.error('Logout failed:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h2>Firebase Anonymous Authentication Test</h2>

      {error && (
        <div style={{ color: 'red', marginBottom: '10px', padding: '10px', border: '1px solid red', borderRadius: '4px' }}>
          Error: {error}
        </div>
      )}

      {isAuthenticated() ? (
        <div>
          <h3>User Authenticated!</h3>
          <p><strong>User ID:</strong> {user?.id}</p>
          <p><strong>Name:</strong> {user?.firstName} {user?.lastName}</p>
          <p><strong>Email:</strong> {user?.email || 'Anonymous'}</p>
          <p><strong>Plan:</strong> {user?.planStatus}</p>
          <p><strong>Private Code:</strong> {user?.privateCode}</p>

          <button
            onClick={handleLogout}
            disabled={loading}
            style={{
              padding: '10px 20px',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: loading ? 'not-allowed' : 'pointer',
              marginTop: '10px'
            }}
          >
            {loading ? 'Logging out...' : 'Logout'}
          </button>
        </div>
      ) : (
        <div>
          <p>No user is currently authenticated.</p>
          <button
            onClick={handleAnonymousSignIn}
            disabled={loading}
            style={{
              padding: '10px 20px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? 'Signing in...' : 'Sign In Anonymously'}
          </button>
        </div>
      )}
    </div>
  );
};

export default AnonymousTest;
